import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import '../../css/DataTable.css';
import '../../css/Dialog.css';

const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    messageSecond,
    cancelLabel,
    confirmLabel,
    confirmColor,
    isDelete = false, // New prop to handle delete styling
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      disableRestoreFocus
      slotProps={{ paper: { className: 'modern-dialog' } }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle className={`modern-dialog-title ${isDelete ? 'delete-header' : ''}`}>
        <span className="modern-dialog-title-text">{title}</span>
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="modern-dialog-close-btn"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent className="modern-dialog-content">
        <Typography variant="body1" sx={{ color: '#334155', lineHeight: 1.6 }}>
          {message}
        </Typography>
        {messageSecond && (
          <Typography variant="body2" className='associated-message'>
            {messageSecond}
          </Typography>
        )}
      </DialogContent>
      
      <DialogActions className="modern-dialog-actions">
        <Button 
          onClick={onClose} 
          variant="outlined" 
          color="inherit"
          sx={{ borderColor: '#e2e8f0', color: '#64748b' }}
        >
          {cancelLabel || 'Cancel'}
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color={confirmColor || (isDelete ? 'error' : 'primary')}
          className={isDelete ? 'confirm-delete-btn' : ''}
          disableElevation
        >
          {confirmLabel || 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
